import Spinner from '@youversion/design-system-icons/lib/Spinner';
import { useTranslation } from 'next-i18next';

import { useGetGivingStatementQuery } from '@/graphql/history';

interface Props {
  onClick: () => void;
  year: number;
}
export function DownloadButton({ year, onClick }: Props) {
  const { t } = useTranslation('common');
  const { data, isLoading, isFetching } = useGetGivingStatementQuery({ statementYear: year });

  const downloadUrl = data?.getGivingStatement.downloadUrl ?? '';

  if (isFetching) {
    return <Spinner className='animate-spin text-text-light dark:text-text-dark h-3 w-3' />;
  } else {
    return (
      <a
        aria-disabled={isLoading}
        className='font-bold text-text-light dark:text-text-dark disabled:text-text-muted-light dark:disabled:text-text-muted-dark cursor-pointer'
        href={downloadUrl}
        onClick={onClick}
        rel='noreferrer'
        target='_blank'
      >
        {t('giving.cta.download')}
      </a>
    );
  }
}
